import { render, staticRenderFns } from "./InputAnswer.vue?vue&type=template&id=5da01f0c&scoped=true&"
import script from "./InputAnswer.vue?vue&type=script&lang=js&"
export * from "./InputAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da01f0c",
  null
  
)

export default component.exports